import SkeletonValuePlaceholder from 'src/components/SkeletonValuePlaceholder/SkeletonValuePlaceholder';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import MarketIcon from 'src/components/Utils/MarketIcon';
import { cj } from 'src/utils/classNames';

export type VaultStatProps = {
	label: string;
	value: React.ReactNode | string | undefined;
	valueClassName?: string;
	loading?: boolean;
	marketSymbol?: string;
	tooltip?: string;
	subValue?: React.ReactNode;
	icon?: React.ReactNode;
};

const VaultStat = (props: VaultStatProps) => {
	const text = <span className="typo-b4">{props.label}</span>;
	return (
		<div className="flex w-full flex-row items-center justify-between gap-y-xs border-none sm:flex-col sm:items-start">
			<div className="flex items-center gap-1 text-text-secondary">
				{props.tooltip ? (
					<Tooltip content={props.tooltip}>{text}</Tooltip>
				) : (
					text
				)}
			</div>
			{props.loading ? (
				<SkeletonValuePlaceholder className="h-6 w-20" loading />
			) : (
				<div className="flex flex-col gap-2">
					<div className="flex items-center gap-1">
						{props.icon ? (
							props.icon
						) : props.marketSymbol ? (
							<MarketIcon
								marketSymbol={props.marketSymbol}
								className="size-lg sm:size-xl"
							/>
						) : null}
						<span className={cj('typo-t4 sm:typo-h5', props.valueClassName)}>
							{props.value}
						</span>
					</div>
					{props.subValue}
				</div>
			)}
		</div>
	);
};

export const VaultStatsSkeleton = (props: { stats: VaultStatProps[] }) => {
	return (
		<div className="flex w-full flex-col gap-4 rounded-sm border-none bg-container-bg p-4 sm:flex-row sm:gap-x-8 md:p-6">
			{props.stats.map((stat) => {
				return <VaultStat key={stat.label} {...stat} />;
			})}
		</div>
	);
};
